module.exports = __webpack_public_path__ + "static/img/5427_phase_function_Paper_Points.f08ddec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5427_phase_function_Paper_Points.png
// module id = GQ6K
// module chunks = 0